import React from 'react'

import Select from '@/components/forms/Select'
import { FormField } from '@/components/forms/FormField'

export const OrganizationFilter = ({ ...props }) => {
  return (
    <FormField data-testid={props.dataTestId ? props.dataTestId : 'organization-dropdown'}>
      <label>Organization</label>
      <div data-testid="organization-select">
        <Select placeholder="Select Organization" fixedWidth {...props} />
      </div>
    </FormField>
  )
}
